import Carousel from "react-elastic-carousel";
import Item from "./Item";
import React from "react";
import "./mobileSlider.css";
import section8Img1 from "../assets/section8Img1.png";
import section8Img2 from "../assets/section8Img2.png";
import section8Img3 from "../assets/section8Img3.png";
import section8Img4 from "../assets/section8Img4.png";
import section8Img5 from "../assets/section8Img5.png";
import Section8Element from "../components/section8Element/section8Element";

const MobileSlider = ({numberOfSlides, title, children}) => {
    const breakPoints = [
      { width: 1, itemsToShow: numberOfSlides },
      { width: 550, itemsToShow: numberOfSlides },
      { width: 768, itemsToShow: numberOfSlides },
      { width: 1200, itemsToShow: numberOfSlides },
    ];
  return (
    <div>
      <div className="sectionEight-heading" >
        <h1 style={{ fontSize:'25px', marginLeft: '20px',}}>{title}</h1>
      </div>
      <div className="sectionEight-pic-wrapper" >
        <Carousel breakPoints={breakPoints}>
          {children }
        </Carousel>
      </div>
    </div>
  );
};

export default MobileSlider;
